/*服贸会*/

import getTranslation from '@/locale/getTranslation'
export default [
  //展会服务
  {
    path: '/exhibitionServices',
    name: 'exhibitionServices',
    component: resolve =>
      require(['@/views/serviceTrade/exhibitionServices'], resolve),
    children: [
      {
        path: '/',
        redirect: 'list'
      },
      {
        path: 'list',
        name: 'exhibitionServicesList',
        meta: {
          title: getTranslation('展会服务'),
          keepAlive: true
        },
        component: resolve =>
          require(['@/views/serviceTrade/exhibitionServices/list'], resolve)
      },
      {
        path: 'detail',
        name: 'exhibitionServicesDetail',
        component: resolve =>
          require(['@/views/serviceTrade/exhibitionServices/detail'], resolve)
      },
      {
        path: 'introduce',
        name: 'exhibitionIntroduce',
        meta: {
          title: getTranslation('展会介绍'),
          keepAlive: true
        },
        component: resolve =>
          require([
            '@/views/serviceTrade/exhibitionServices/introduce'
          ], resolve)
      },
      {
        path: '*',
        redirect: 'list'
      }
    ]
  },
  //展商名录
  {
    path: '/exhibitorList',
    name: 'exhibitorList',
    component: resolve =>
      require(['@/views/serviceTrade/exhibitorList'], resolve),
    children: [
      {
        path: '/',
        redirect: 'list'
      },
      {
        path: 'list',
        name: 'exhibitorListList',
        meta: {
          title: getTranslation('展商名录'),
          keepAlive: true
        },
        component: resolve =>
          require(['@/views/serviceTrade/exhibitorList/list'], resolve),
        beforeEnter: (to, from, next) => {
          window._isMobile ? next() : next({ name: 'exhibitor-list' })
        }
      },
      {
        path: 'detail',
        name: 'exhibitorListDetail',
        meta: {
          title: ''
        },
        component: resolve =>
          require(['@/views/serviceTrade/exhibitorList/detail'], resolve),
        beforeEnter: (to, from, next) => {
          window._isMobile
            ? next()
            : next({ name: 'exhibitor-detail', query: to.query })
        }
      },
      {
        path: 'kf',
        name: 'kf',
        meta: {
          title: getTranslation('企业成员')
        },
        component: resolve =>
          require(['@/views/serviceTrade/exhibitorList/kf'], resolve)
      },
      {
        path: '*',
        redirect: 'list'
      }
    ]
  },
  //往届回顾
  {
    path: '/previousReview',
    name: 'previousReview',
    component: resolve =>
      require(['@/views/serviceTrade/previousReview'], resolve),
    meta: {
      title: getTranslation('往届回顾'),
      keepAlive: true
    }
  },
  //会议交流
  {
    path: '/communication',
    name: 'communication',
    component: resolve =>
      require(['@/views/serviceTrade/communication'], resolve),
    meta: {
      title: getTranslation('会议交流'),
      keepAlive: true
    }
  },
  //承办机构详情
  {
    path: '/accountDetail',
    name: 'accountDetail',
    component: resolve =>
      require(['@/views/serviceTrade/communication/accountDetail'], resolve),
    meta: {
      title: ''
    }
  },
  //
  //展区图册
  {
    path: '/exhibitionAtlas',
    name: 'exhibitionAtlas',
    component: resolve =>
      require(['@/views/serviceTrade/exhibitionAtlas'], resolve),
    meta: {
      title: getTranslation('展区图册'),
      keepAlive: true
    }
  },
  //活动咨询
  {
    path: '/activity',
    name: 'activity',
    component: resolve => require(['@/views/serviceTrade/activity'], resolve),
    children: [
      {
        path: '/',
        redirect: 'detail'
      },
      {
        path: 'detail',
        name: 'activityDetail',
        component: resolve =>
          require(['@/views/serviceTrade/activity/detail'], resolve),
        meta: {
          title: ''
        }
      }
    ]
  }
]
